export default __webpack_public_path__ + "static/media/classroom.36f4c386.png";